// extracted by mini-css-extract-plugin
export default {"loader":"SmallLoader_loader__iS0DZ","rotation":"SmallLoader_rotation__9oGU-"};